<div class="spinner" *ngIf="loading" [class.small]="small">
  <img src="assets/gifs/fdi-spinner.svg" />
</div>
